import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {formatDate} from "shared/lib/fns";
import {DatePicker, SearchInput} from "shared/ui";
import {PlanSearchParamKey} from "features/plan/types";

export const PlanFilter = () => {
  const [params, setSearchParams] = useSearchParams();
  const {t} = useTranslation("shipping");
  
  const planDate = useMemo(() => {
    const planDate = params.get(PlanSearchParamKey.planDate);
    if (planDate) {
      return new Date(planDate)
    }
    return new Date();
  }, [params])
  
  const handleFilterCluster = (value?: string) => {
    setSearchParams((prev) => {
      if (value) prev.set(PlanSearchParamKey.clusterIdStartswith, value); else prev.delete(PlanSearchParamKey.clusterIdStartswith)
      return prev;
    });
  }
  
  const handleFilterDate = (date: Date) => {
    setSearchParams((prev) => {
      prev.set(PlanSearchParamKey.planDate, formatDate(date));
      return prev;
    });
  };
  
  const handleFilterByRound = (selectedOption?: string | number) => {
    setSearchParams(prev => {
      if (selectedOption) prev.set(PlanSearchParamKey.planNo, selectedOption + ""); else prev.delete(PlanSearchParamKey.planNo)
      return prev;
    })
  };
  
  return (<div className={"flex flex-row gap-2 items-center"}>
    <div className={"text-md whitespace-nowrap shrink-0"}>{t("Type search")}</div>
    <SearchInput
      placeholder={t("cluster_id")}
      maxLength={16}
      inputMode="numeric"
      size={"sm"}
      value={params.get(PlanSearchParamKey.clusterIdStartswith) ?? ""}
      onSearch={handleFilterCluster}
    />
    <DatePicker
      value={planDate}
      size={"sm"}
      placeholder={t("plan date")}
      onChange={handleFilterDate}
    />
    <SearchInput
      placeholder={t("Filter by plan no")}
      maxLength={3}
      size={"sm"}
      inputMode="numeric"
      value={params.get(PlanSearchParamKey.planNo) ?? ""}
      onSearch={handleFilterByRound}
      onValueChange={handleFilterByRound}
    />
  </div>);
};
